import { createSelector } from 'reselect';

// Base selectors to get the slices of state
const getStepsDataState = state => state?.stepsReducer;

const getApiCallState = state => state?.apiCallReducer;

const getDressToolFlagState = state => state?.dressToolFlagReducer;


// Selector to get dressToolStepsData from stepsReducer
export const getDressToolStepsData = createSelector(
  [getStepsDataState],
  (stepsState) => stepsState?.dressToolStepsData
);

// Selector to get dressToolApiCall from apiCallReducer
export const getDressToolApiCall = createSelector(
  [getApiCallState],
  (apiCallState) => apiCallState?.dressToolApiCall
);

// Selector to get dressToolFlag from dressToolFlagReducer
export const getDressToolFlagData = createSelector(
  [getDressToolFlagState],
  (dressToolFlagState) => dressToolFlagState?.dressToolAggregateData
);
